export default {
  activity: '/workshop/activity',
};
